import React from 'react'
import { Helmet } from 'react-helmet'
import SecondaryHeader from '../masterLayout/SecondaryHeader'
import { Link } from 'react-router-dom'
const Dispensaries = () => {
 return (
  <React.Fragment>
   <Helmet>
    <title>Dispensaries</title>
   </Helmet>
   <SecondaryHeader
     page_title="Dispensaries"
     banner={require('../assets/images/dispensaries/banner.jpg')}
    />
   <div className="sectionWrap">
    <div className="sectionContainer">
     <div className="dispensaries-page">
      <section className="intro-copy">
       <h4 className="lead">
        A better business model rooted in care, not coupons.
       </h4>
       <p>
        Bennabix connects dispensaries to a growing population of medically qualified patients. As care evolves, we help you serve an engaged, wellness–focused audience, with cannabis becoming a trusted part of mainstream treatment.
       </p>
       <p>
        The market is crowded with discounts and promotions leading the way. Bennabix offers something different: A smarter, more sustainable path to growth.
       </p>
       <p>
        We partner with employers and health plans to provide covered medical cannabis benefits, connecting dispensaries to qualified patients with real needs and health–plan–backed purchasing power.
       </p>
      </section>

      <section className="bp-highlight dispensary-highlights">
       <h3 className="heading">By joining the Bennabix Dispensary Network, you:</h3>
       <div className="two-col bullets">
        <div className="col media">
         <img src={require('../assets/images/dispensaries/team.jpg')} alt="Team of professionals" />
        </div>
        <div className="col text">
         <ul>
          <li>Serve high–value customers with consistent, medical–driven demand</li>
          <li>Receive direct payments from Bennabix</li>
          <li>Shift away from discount–based sales toward predictable, recurring revenue</li>
          <li>Become part of a trusted ecosystem that prioritizes education, care, and outcomes</li>
         </ul>
        </div>
       </div>
      </section>

      <section className="footer-cta">
        <p>
         Bennabix is building a selective network of preferred medical cannabis dispensaries with geographic exclusivity.
        </p>
        <p>
         Find out how your dispensary can become a part of the Bennabix Dispensary Network. Contact us at team@bennabix.com.
        </p>
       </section>
     </div>
    </div>
   </div>
  </React.Fragment>
 )
}
export default Dispensaries